import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getdataByIdim_principal = (id) => {
  return httpClientImmigration.get(server.IM_PRINCIPAL + `/getbyid/${id}`);
};

export const getAllim_principal_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_PRINCIPAL + `/getAllim_principal_Company`,
    query,
  );
};

export const getAllim_principal_CompanyPagination = (
  company_id,
  pageNum,
  limitNum,
  sortBy,
  sortOrderUpper,
) => {
  return httpClientImmigration.get(
    server.IM_PRINCIPAL + `/getAllim_principal_CompanyPagination`,
    {
      params: {
        company_id: company_id,
        page: pageNum,
        limit: limitNum,
        sortBy: sortBy,
        sortOrder: sortOrderUpper,
      },
    },
  );
};

export const getAllim_principal_CompanyPaginationV2 = (
  company_id,
  pageNum,
  limitNum,
  sortBy,
  sortOrderUpper,
  search,
) => {
  return httpClientImmigration.get(
    server.IM_PRINCIPAL + `/getAllim_principal_CompanyPaginationV2`,
    {
      params: {
        company_id: company_id,
        page: pageNum,
        limit: limitNum,
        sortBy: sortBy,
        sortOrder: sortOrderUpper,
        search: search,
      },
    },
  );
};

export const getfile_numberim_principal_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_PRINCIPAL + `/getfile_numberim_principal_Company`,
    query,
  );
};

export const addim_principal = (data) => {
  return httpClientImmigration.post(server.IM_PRINCIPAL + `/`, data);
};

export const updateim_principal = (id, data) => {
  return httpClientImmigration.put(server.IM_PRINCIPAL + `/${id}`, data);
};

export const updateim_principal_nofile = (id, data) => {
  return httpClientImmigration.put(
    server.IM_PRINCIPAL + `/updateNofile/${id}`,
    data,
  );
};

export const deleteim_principal = (id) => {
  return httpClientImmigration.delete(server.IM_PRINCIPAL + `/${id}`);
};

export const getAll_visa_types = (id) => {
         return httpClientImmigration.get(
           server.IM_PRINCIPAL + `/getAll_visa_types_byCompany/${id}`,
         );
};
       
export const getAll_ltr_category = (id) => {
         return httpClientImmigration.get(
           server.IM_PRINCIPAL + `/getAll_ltr_category_byCompany/${id}`,
         );
       };
;
export const getAll_tax_type = (id) => {
         return httpClientImmigration.get(
           server.IM_PRINCIPAL + `/getAll_tax_type_byCompany/${id}`,
         );
       };

export const getAll_type_of_income = (id) => {
         return httpClientImmigration.get(
           server.IM_PRINCIPAL + `/getAll_type_of_income_byCompany/${id}`,
         );
       };